import { Component, OnInit, HostBinding } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Toast, ToastrService, ToastPackage } from 'ngx-toastr';
import { Utils } from '../../../../utils';


export class ScannerNotificationParams
{
  constructor(public title: string = 'Notification', public text: string = '', public error: boolean = false)
  {  
  }
}

@Component({
  selector: '[simple-notification]',
  template: require('./scanner-notification.component.html'),
  styles: [require('./scanner-notification.component.css')],
  animations: [
    trigger('flyInOut', [
        state('inactive', style({
            
            opacity: 0
        })),
        state('active', style({ opacity: 100 })),
        state('removed', style({ opacity: 0 })),
        transition('inactive => active', animate('{{ easeTime }}ms {{ easing }}')),
        transition('active => removed', animate('{{ easeTime }}ms {{ easing }}'))
    ])],
  preserveWhitespaces: false,
})

export class ScannerNotificationComponent extends Toast implements OnInit {
  params: ScannerNotificationParams;

  @HostBinding('class.error')
  get error()
  {
      return this.params.error;
  }
  
  constructor(protected toastrService: ToastrService, public toastPackage: ToastPackage) 
  {
    super(toastrService, toastPackage);
    this.params = JSON.parse(Utils.decodeHTMLEntities(this.message as string));
  }

  ngOnInit() {
  }

}
